import { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/**
 * i18n
 */
import { useIntl } from 'react-intl';

function LeavingPageDialog({ when, onOK, setChoseToStay = () => {}, subtitle }) {
  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const unblockRef = useRef(null);

  const intl = useIntl();

  useEffect(() => {
    if (!when) return;
    unblockRef.current = history.block((prompt) => {
      setCurrentPath(prompt.pathname);
      setShowPrompt(true);
      return false;
    });
    return () => {
      if (unblockRef.current) {
        unblockRef.current();
        unblockRef.current = null;
      }
    };
  }, [history, when]);

  const handleOK = useCallback(async () => {
    if (onOK) {
      const canRoute = await Promise.resolve(onOK());
      if (canRoute) {
        if (unblockRef.current) {
          unblockRef.current();
          unblockRef.current = null;
        }
        history.push(currentPath);
      }
    }
  }, [currentPath, history, onOK]);

  const handleCancel = useCallback(async () => {
    setChoseToStay(true);
    setShowPrompt(false);
  }, []);

  return (
    <Dialog maxWidth="xs" open={showPrompt} fullWidth onClose={handleCancel} aria-labelledby="max-width-dialog-title">
      <DialogTitle id="max-width-dialog-title">{intl.formatMessage({ id: 'leavingDialog.title' })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{subtitle || intl.formatMessage({ id: 'leavingDialog.subtitle' })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleCancel}>
          {intl.formatMessage({ id: 'leavingDialog.stay' })}
        </Button>
        <Button variant="contained" onClick={handleOK} color="primary">
          {intl.formatMessage({ id: 'leavingDialog.leave' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

LeavingPageDialog.propTypes = {
  when: PropTypes.bool,
  onOK: PropTypes.func,
  onCancel: PropTypes.func,
  setChoseToStay: PropTypes.func,
  subtitle: PropTypes.string,
};

export default LeavingPageDialog;
